import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carriers-list',
  templateUrl: './carriers-list.component.html',
  styleUrls: ['./carriers-list.component.scss'],
})
export class CarriersListComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
